import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const DiscoveryTooltip = ({ children, placement, text, noWrap }) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip className="discovery-tooltip">
          <div 
            className={`p-2 ${noWrap && 'text-nowrap'}`}
          >
            {text}
          </div>
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
}

export default DiscoveryTooltip;